"use strict";

export const truncate = (function () {
    let lineHeight = 20;
    let prevWidth = 0;

    const init = function () {
        // If there is no booklist, do nothing
        if (!document.querySelector(".booklist")) {
            return;
        }

        prevWidth = document.querySelector(".booklist").clientWidth;

        const paragraphs = document.querySelectorAll(
            ".BookNookItem .is_from_rte p:last-child"
        );

        // Save the line height of any paragraph
        const styles = window.getComputedStyle(paragraphs[0]);
        lineHeight = getLineHight(styles);

        paragraphs.forEach((p) => {
            maybeTruncate(p, 1);
        });

        // When the "Read more" link is clicked, untruncate the paragraph
        document.body.addEventListener("click", function (e) {
            if (e.target.matches(".readMore")) {
                const p = e.target.closest("p");

                untruncate(p);

                // Give element a class to indicate it's been untruncated
                p.classList.add("untruncated");
            }
        });

        // When the book list wrapper is resized, re-truncate the paragraphs (resizeobserver)
        const resizeObserver = new ResizeObserver((entries) => {
            entries.forEach((entry) => {
                // If the width hasn't changed do nothing
                if (entry.contentRect.width === prevWidth) {
                    return;
                }

                prevWidth = entry.contentRect.width;

                const paragraphs = entry.target.querySelectorAll(
                    ".BookNookItem .is_from_rte p:last-child"
                );
                paragraphs.forEach((p, i) => {
                    maybeTruncate(p, 1);
                });
            });
        });

        const bookListWrapper = document.querySelector(".booklist");
        resizeObserver.observe(bookListWrapper);
    };

    function getLineHight(styles) {
        // Create a new hidden element to test the line height
        const testElement = document.createElement("span");
        testElement.style.visibility = "hidden"; // Hide from user
        testElement.style.whiteSpace = "nowrap"; // Ensure text stays on one line
        testElement.style.fontSize = styles.fontSize; // Match the font size
        testElement.style.fontFamily = styles.fontFamily; // Match the font family
        testElement.style.lineHeight = styles.lineHeight; // Match the line height
        testElement.style.padding = 0; // Reset padding
        testElement.style.margin = 0; // Reset margin
        testElement.style.border = 0; // Reset border
        testElement.style.position = "absolute"; // Remove from normal flow

        // Set the text content to a single character
        testElement.innerText = "X";

        // Add the test element to the DOM
        document.body.appendChild(testElement);

        // Get the line height from the test element
        const lineHeight = testElement.offsetHeight;

        // Clean up: Remove the test element from the DOM
        document.body.removeChild(testElement);

        return lineHeight;
    }

    function maybeTruncate(element, lines = 1) {
        // If the element has already been untruncated, do nothing
        if (element.classList.contains("untruncated")) {
            return;
        }

        // Get the line height of the element
        const minHeight = lineHeight * lines;

        // Make a copy of the element to measure the height without truncating
        const clone = element.cloneNode(true);
        clone.style.height = "";
        clone.style.overflow = "";
        clone.style.visibility = "hidden";
        // Remove the read more link
        const readMore = clone.querySelector(".readMore");
        if (readMore) {
            readMore.remove();
        }
        element.parentElement.appendChild(clone);

        // If the element height is less than or equal to the line height, this does not need truncating
        if (clone.clientHeight <= minHeight) {
            // If the element has been truncated, untruncate it
            element.querySelector(".readMore") && untruncate(element);
        } else {
            // If the element has not been truncated, truncate it
            !element.querySelector(".readMore") && truncate(element, lines);
        }

        // Clean up: Remove the clone from the DOM
        clone.remove();
    }

    function truncate(element, lines = 1) {
        // Get the line height of the element
        const minHeight = lineHeight * lines;

        // Set the element height to min lines
        element.style.height = minHeight + "px";

        // Change the overflow to hidden
        element.style.overflow = "hidden";

        // Add a "Read more" link inside the element
        const readMore = document.createElement("button");
        readMore.href = "#";
        readMore.innerHTML = "&nbsp;&nbsp; More";
        readMore.classList.add("readMore");
        readMore.style.height = lineHeight + "px";
        element.appendChild(readMore);
    }

    function untruncate(element) {
        // Remove the height style
        element.style.height = "";

        // Remove the overflow style
        element.style.overflow = "";

        // Remove the "Read more" link
        const readMore = element.querySelector(".readMore");
        if (readMore) {
            readMore.remove();
        }
    }

    return { init };
})();
